export const colorMapping = {
  red: 'r',
  blue: 'b',
  yellow: 'y',
  black: 'x',
};

export const reverseColorMapping = {
  'r': 'red',
  'b': 'blue',
  'y': 'yellow',
  'x': 'black'
};

export const convertToJSON = (puzzleName, serialNo, difficulty, description, funFact, grid, bookletNumber) => {
  const pattern = grid[0].map((_, colIndex) =>
      grid.map(row => colorMapping[row[colIndex].color])
  );

  return {
      Name: puzzleName,
      SerialNumber: serialNo,
      BookletNumber: bookletNumber,
      Difficulty: difficulty,
      Description: description,
      FunFact: funFact,
      Pattern: pattern,
  };
};

export const getDifficulty = (ficeScore) => {
  if (ficeScore < 30) return 'Easy';
  if (ficeScore < 45) return 'Medium';
  if (ficeScore < 60) return 'Hard';
  return 'Expert';
};